"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createFaasProcedureConfig = require("@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig");
var _withOriginServerHeader = _interopRequireDefault(require("./withOriginServerHeader"));
var _withExpandedError = _interopRequireDefault(require("./withExpandedError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// https://explorer.aexp.com/functions/ReadCustomerProductDetails.v1
const baseConfig = (0, _createFaasProcedureConfig.createFaasProcedureConfig)('ReadCustomerProductDetails.v1', _ref => {
  let {
    headers,
    ...args
  } = _ref;
  return {
    ...(headers ? {
      headers
    } : {}),
    body: JSON.stringify(args)
  };
});
var _default = (0, _withExpandedError.default)((0, _withOriginServerHeader.default)(baseConfig));
exports.default = _default;